import genresSource from "./genres.json";

const genres = Object.fromEntries(
  (genresSource.genres || []).map((genre) => [
    genre.id,
    genre.description_zh || genre.description,
  ])
);

const subgenres = Object.fromEntries(
  (genresSource.genres || []).flatMap((genre) =>
    (genre.subgenres || []).map((subgenre) => [
      subgenre.id,
      subgenre.title_zh || subgenre.title,
    ])
  )
);

export const genresZh = { genres, subgenres };
